import React from 'react';

const CardLoader = () => {
  return (
    <div className="w-full max-w-lg mx-auto rounded-2xl shadow-lg bg-white dark:bg-gray-800 overflow-hidden relative border border-gray-100 dark:border-gray-700 my-4 flex flex-col animate-pulse">
      {/* صورة */}
      <div className="w-full h-48 bg-gray-200 dark:bg-gray-900 flex items-center justify-center overflow-hidden">
        <div className="w-full h-full" />
      </div>
      {/* محتوى البطاقة */}
      <div className="p-3 flex flex-col gap-2 items-center justify-center w-full">
        {/* الاسم */}
        <div className="flex flex-row items-center gap-2 justify-center w-full mt-2">
          <div className="h-4 w-32 bg-gray-200 dark:bg-gray-700 rounded" />
          <div className="h-4 w-20 bg-gray-100 dark:bg-gray-800 rounded" />
        </div>
        {/* الوصف */}
        <div className="w-full flex flex-col gap-1 mt-1">
          <div className="h-3 w-full bg-gray-200 dark:bg-gray-700 rounded" />
          <div className="h-3 w-3/4 bg-gray-100 dark:bg-gray-800 rounded" />
        </div>
        {/* الإضافات */}
        <div className="flex flex-wrap gap-1 justify-center w-full mt-1 mb-1">
          <div className="h-5 w-16 bg-gray-100 dark:bg-gray-700 rounded-full" />
          <div className="h-5 w-14 bg-gray-200 dark:bg-gray-800 rounded-full" />
          <div className="h-5 w-20 bg-gray-100 dark:bg-gray-700 rounded-full" />
        </div>
      </div>
      {/* الخط والسعر والسعرات */}
      <div className="w-full mt-auto px-3 pb-3">
        <div className="w-full border-t border-gray-200 dark:border-gray-700 my-2"></div>
        <div className="flex flex-row justify-between items-center w-full pt-1">
          <div className="h-4 w-20 bg-gray-200 dark:bg-gray-700 rounded" />
          <div className="h-4 w-16 bg-gray-100 dark:bg-gray-800 rounded" />
        </div>
      </div>
    </div>
  );
}

export default CardLoader;
